export const mockInfo = {
    outer_title: "青春活力健康基礎",
    subsequent_texts: [
      {
        type: "text",
        title: "適用族群",
        content: "學生、社會新鮮人、一般年輕族群"
      },
      {
        type: "accordion",
        title: "檢查項目",
        content: [
          {
            title: "理學檢查",
            items: [
              { name: "身高", description: "Body Height" },
              { name: "體重", description: "Body Weight" },
              { name: "其他檢驗", description: "Others" }
            ]
          },
          {
            title: "血球檢查",
            items: [
              { name: "糖化血色素", description: "Hemoglobin A1c" },
              { name: "空腹血糖", description: "FPG" },
              { name: "血脂檢測", description: "TC/HDL/LDL/TG" }
            ]
          },
          {
            title: "肝腎功能",
            items: [
              { name: "肝功能", description: "AST/ALT" },
              { name: "腎功能", description: "BUN/Creatinine/eGFR" }
            ]
          }
        ]
      },
      // {
      //   type: "image",
      //   title: "示意圖",
      //   src: "https://placehold.co/js/main.js?id=b63f784ac81a881fd900055cc85b393b",
      //   alt: "範例圖片"
      // },
      {
        type: "text-emphasized",
        title: "費用",
        content: "NT$ 2,600"
      }
    ]
  };
